import { keyframes } from '@emotion/react'

export const KEYFRAMES = keyframes`
  100% { transform: rotate(1turn) }
`

export const RATIO = 4.375
